<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>门店</label>
          <el-select v-model="shopId" placeholder="Select" class="select-item">
            <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>记录类型</label>
          <el-select v-model="type" placeholder="Select" class="select-item">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>负责人</label>
          <el-input type="text" v-model="searchValue" placeholder="请输入负责人" class="select-item"  clearable>
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
        </div>
        <div class="dialog-input-item">
          <label>会员账户</label>
          <el-select v-model="balanceType" placeholder="Select" class="select-item">
            <el-option v-for="item in balanceTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>

      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons  type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>
        <div class="dialog-input-btn">
          <ElButtons  type="success" icon="Wallet"  @click="openDialog"> 充值 </ElButtons>
        </div>
        <div class="dialog-input-btn">
          <ElButtons  type="danger" icon="Wallet"  @click="checkDetail(-1)"> 抵扣 </ElButtons>
        </div>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
        @sort-change="sortChange"
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="createTime" label="创建时间" width="112" sortable='custom'/>
      <el-table-column property="createTime" label="记录类型" width="100">
        <template #default="scope">
          {{scope.row.type == 1?'充值记录':scope.row.type == -2?'抵扣记录':scope.row.type == 2?'赠送记录':''}}
        </template>
      </el-table-column>
      <el-table-column property="shopName" label="门店" width="100"/>
      <el-table-column property="" label="记录明细">
        <template #default="scope">
          <p>{{scope.row.contentObj.content}}</p>
          <p style="margin-left: -5px;">【{{scope.row.contentObj.title}}】</p>
        </template>
      </el-table-column>
      <el-table-column property="" label="付款截图" width="210">
        <template #default="scope">
          <el-space wrap>
            <div class="img-box" v-for="(item, index) in scope.row.detailImgList" :key="item.id" @click="showImg(scope.row.detailImgList, index)">
              <el-image style="width: 80px; height: 80px;" fit="cover" :src="item.smallImg" ><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </div>
          </el-space>
        </template>
      </el-table-column>
      <el-table-column property="relationAdminName" label="负责人" width="100"/>
      <el-table-column property="updateTime" label="更新时间" width="112" sortable='custom'/>
      <el-table-column property="relationAdminName" label="操作" width="80">
        <template #default="scope">
          <el-button v-if="scope.row.type == 1" type="success" size="small" @click="editPayDailog(scope.$index, scope.row)">编辑</el-button>
          <el-button v-if="scope.row.type == -2" type="danger" size="small" @click="checkDetail(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllShopList, getWalletDetailPageList, getRecordShops, getUserInfo} from '@/api/url';
// import Dialog from '@/assets/js/dialog'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange";
import Dialog from "@/assets/js/dialog";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import {decimal_NUM} from "@/assets/shared/util";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
import ImgViewer from "@/assets/js/imageViewer";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange},
  data() {
    return {
      pageDataList: [],
      id: this.value.id,
      userForm: this.value.userForm,
      pageType: this.value.pageType,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      searchValue: '',
      searchType: 1,

      type: this.value.type?this.value.type:0,
      typeArray: [
        {label: '不限', value: 0},
        {label: '充值记录', value: 1},
        {label: '抵扣记录', value: -2},
        {label: '赠送记录', value: 2},
      ],

      balanceType: 0,
      balanceTypeArray: [
        {label: '不限', value: 0},
        {label: '500账户', value: 1},
        {label: '1000账户', value: 2},
        {label: '1500账户', value: 3},
        {label: '2500账户', value: 4}
      ],

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      sort: 2,

    }
  },
  methods: {

    showImg(list, index) {
      let imgList = []
      list.map(item => {
        imgList.push(item.img)
      })
      ImgViewer.open({
        imgList: imgList,
        imgIndex: index
      })
    },


    //排序
    sortChange(column) {
      if(column.prop == 'createTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'updateTime') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.id;
      param['balanceType'] = this.balanceType;
      param['type'] = this.type;
      param['shopId'] = this.shopId;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['sort'] = this.sort;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getWalletDetailPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];

          this.pageDataList.map(item => {
            let arr = item.content.split('；')
            let obj = {}
            obj.title = arr[arr.length-1]
            arr.splice(-1, 1)
            obj.content = arr.join('；')
            item.contentObj = obj
          })

          this.totalRow = result['total'];
          this.pageSize = result['size'];
          if(this.pageDataList.length > 3) {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList.slice(0,3)));
          } else {
            sessionStorage.setItem('userLog', JSON.stringify(this.pageDataList));
          }
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    getShopList() {
      let param = {}
      param['userId'] = this.id
      param['type'] = 2
      getFormData(getRecordShops, param).then(data=> {
        data.data.map((item) => {
          this.shopIdArr.push(item)
        })
        this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
      })
    },

    getUserInfo() {
      let param = {};
      param['id'] = this.id;
      getFormData(getUserInfo, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.userForm = data.data
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      }).catch(()=> {
      })
    },


    openDialog() {
      let walletDetail = {}
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: this.userForm,
          walletDetail: walletDetail,
          width: '700px'
        },
        confirm: () => {
          this.getPage()
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    editPayDailog(idx, row) {

      let visibleShopList = JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1)
      if(visibleShopList.every(item => item.id != row.shopId)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '当前角色没有该门店的编辑权限',
          type: 'warning'
        })
        return false
      }

      let walletDetail = Object.assign({}, row);
      Dialog.open({
        title: '',
        component: SearchInfoDialog,
        data: {
          userForm: this.userForm,
          walletDetail: walletDetail,
          width: '700px',
          editState: true,
          idx: idx,
        },
        confirm: () => {
          this.getPage()
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },


    checkDetail(idx, row) {
      // getFormData(getUserInfo, {id: this.userForm.id}).then(data => {
      //
      // })

      let consumeForm = {}
      let consumeId = 0
      if(idx > -1) {
        consumeForm = Object.assign({}, row);
        consumeId = consumeForm.sourceId
      }
      Dialog.open({
        title: '',
        component: ConsumeDetailDialog,
        data: {
          userForm: this.userForm,
          consumeId: consumeId,
          idx: idx
        },
        confirm: (result) => {
          this.getPage();
          this.getUserInfo()
          sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })

    },


  },
  mounted() {
    this.getShopList()
    this.getPage();
    this.getUserInfo()
  }
}
</script>

<style>
.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}
</style>
